import * as React from 'react';
import { EditorPlugin } from 'roosterjs-editor-core';
import PluginWithUI from '../store/schema/PluginWithUI';
import LazyPlugin from '../store/schema/LazyPlugin';

export default function PluginUI(props: { plugins: EditorPlugin[] }): JSX.Element {
    let uiPluginsInitialValue: PluginWithUI<any>[] = [];

    (props.plugins || []).forEach(plugin => {
        if (isLazyPlugin(plugin)) {
            plugin.addOnImportedCallback(processPlugin);
        } else {
            processPlugin(plugin);
        }
    });

    function processPlugin(plugin: EditorPlugin) {
        // Here the plugin parameter can be the plugin from props.plugins array when it is not a lazy plugin,
        // or the real plugin of a lazy plugin once it is imported
        if (!isUIPlugin(plugin)) {
            // We only handle UIPlugins, so filter out non-UIPlugin first.
            return;
        } else if (uiPlugins && uiPlugins.indexOf(plugin) < 0) {
            // For lazy plugin, after its real plugin is imported, we should already have the state object "uiPlugins".
            // So we can call setUiPlugins() to add this instance
            setUiPlugins([...uiPlugins, plugin]);
        } else if (uiPluginsInitialValue && uiPluginsInitialValue.indexOf(plugin) < 0) {
            // Otherwise, it means uiPlugins hasn't been built yet, and uiPluginsInitialValue should be available.
            // So we can directly push this plugin into uiPluginsInitialValue
            uiPluginsInitialValue.push(plugin);
        }
    }

    const [uiPlugins, setUiPlugins] = React.useState<PluginWithUI<any>[]>(uiPluginsInitialValue);
    uiPluginsInitialValue = null;

    return (
        <>
            {uiPlugins.map(plugin =>
                React.createElement(plugin.getUIComponentClass(), {
                    viewState: plugin.adapter(),
                    editorViewState: plugin.editorAdapter(),
                    plugin: plugin,
                    key: plugin.getName(),
                })
            )}
        </>
    );
}

function isUIPlugin(plugin: EditorPlugin): plugin is PluginWithUI<any> {
    return plugin && !!(plugin as PluginWithUI<any>).getUIComponentClass;
}

function isLazyPlugin(plugin: EditorPlugin): plugin is LazyPlugin<any> {
    return plugin && !!(plugin as LazyPlugin<any>).addOnImportedCallback;
}
